//@flow
const errorlogStateName = 'errorlog'
const localStore = localStorage.getItem(errorlogStateName)

export const errorlogInitialState: any = localStore ? JSON.parse(localStore) : {
    errorlog: {
        errors: [],
        count: 0,
        currentError: null,
        loading: false,
        error: '',
        search: '',
        filters: {
            severity: '',
            source: '',
            since: ''
        },
        pagination: {
            page: 1,
            pageSize: 20,
            pages: 0
        },
        sortField: 'last_seen',
        sortOrder: 'desc',
    }
}

type State = {
    +errorlog: {
        +errors: Array<any>,
        +count: number,
        +currentError: any,
        +loading: boolean,
        +error: string,
        +search: string,
        +filters: {
            +severity: string,
            +source: string,
            +since: string
        },
        +pagination: {
            +page: number,
            +pageSize: number,
            +pages: number
        },
        +sortField: string,
        +sortOrder: string
    }
}

type Action = {
    errors?: Array<any>,
    count?: number,
    errorItem?: any,
    error?: string,
    search?: string,
    filters?: any,
    pagination?: any,
    pageSize?: number,
    page?: number,
    pages?: number,
    sortField?: string,
    sortOrder?: string,
    errorHash?: string
}

export const ActionLoadErrorlogs = 'loadErrorlogs'
export const ActionLoadErrorlogsSuccess = 'loadErrorlogsSuccess'
export const ActionLoadErrorlogsError = 'loadErrorlogsError'
export const ActionSelectErrorlog = 'selectErrorlog'
export const ActionResolveErrorlogSuccess = 'resolveErrorlogSuccess'
export const ActionUnresolveErrorlogSuccess = 'unresolveErrorlogSuccess'
export const ActionClearErrorlogError = 'clearErrorlogError'

export const errorlogActions: any = {
    [ActionLoadErrorlogs]: (state: State) => {
        const next = {
            errorlog: {
                ...state.errorlog,
                loading: true,
                error: ''
            }
        };
        localStorage.setItem(errorlogStateName, JSON.stringify(next))
        return next
    },
    [ActionLoadErrorlogsSuccess]: (state: State, action: Action) => {
        const next = {
            errorlog: {
                ...state.errorlog,
                errors: action.errors || [],
                count: action.count || 0,
                pagination: {
                    ...state.errorlog.pagination,
                    page: action.page || 1,
                    pageSize: action.pageSize || 20,
                    pages: action.pages || 0
                },
                sortField: action.sortField || state.errorlog.sortField,
                sortOrder: action.sortOrder || state.errorlog.sortOrder,
                loading: false,
                error: ''
            }
        };
        localStorage.setItem(errorlogStateName, JSON.stringify(next))
        return next
    },
    [ActionLoadErrorlogsError]: (state: State, action: Action) => {
        const next = {
            errorlog: {
                ...state.errorlog,
                loading: false,
                error: action.error || 'Failed to load error logs'
            }
        };
        localStorage.setItem(errorlogStateName, JSON.stringify(next))
        return next
    },
    [ActionSelectErrorlog]: (state: State, action: Action) => {
        const next = {
            errorlog: {
                ...state.errorlog,
                currentError: action.errorItem
            }
        };
        localStorage.setItem(errorlogStateName, JSON.stringify(next))
        return next
    },
    [ActionResolveErrorlogSuccess]: (state: State, action: Action) => {
        const errors = state.errorlog.errors.map(e =>
            e.error_hash === action.errorHash
                ? { ...e, resolved_at: new Date().toISOString() }
                : e
        );
        const next = {
            errorlog: {
                ...state.errorlog,
                errors,
                error: ''
            }
        };
        localStorage.setItem(errorlogStateName, JSON.stringify(next))
        return next
    },
    [ActionUnresolveErrorlogSuccess]: (state: State, action: Action) => {
        const errors = state.errorlog.errors.map(e =>
            e.error_hash === action.errorHash
                ? { ...e, resolved_at: null, resolved_by: null }
                : e
        );
        const next = {
            errorlog: {
                ...state.errorlog,
                errors,
                error: ''
            }
        };
        localStorage.setItem(errorlogStateName, JSON.stringify(next))
        return next
    },
    [ActionClearErrorlogError]: (state: State) => {
        const next = {
            errorlog: {
                ...state.errorlog,
                error: ''
            }
        };
        localStorage.setItem(errorlogStateName, JSON.stringify(next))
        return next
    }
};

export const getStateName = (): string => errorlogStateName;
